import { useTenantNavigate } from '@app-store'
import { PropsWithChildren, useEffect } from 'react'
import { useAppSelector, RootState } from '../utils/agent.store'
import { USER_PROFILES } from '../utils/constants'

const NavigateToPage: React.FC<{ url: string }> = ({ url }) => {
  const navigate = useTenantNavigate()
  useEffect(() => {
    navigate(url)
  }, [url])
  return <></>
}

export const ReadOnlyProtectedRoute: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const userProfile = useAppSelector(
    (state: RootState) => state.authUser.user?.profile
  )

  if (userProfile && userProfile === USER_PROFILES.READ_ONLY_USER) {
    return <NavigateToPage url="/" />
  }
  if (userProfile !== USER_PROFILES.READ_ONLY_USER) {
    return children
  } else {
    return null
  }
}
